const tabsButtons = document.querySelectorAll(".territory-maps__tab");
const tabsContents = document.querySelectorAll(".territory-maps__tab--content");

if (tabsButtons.length && tabsContents.length) {
  tabsButtons[0].classList.add("isActive");
  tabsContents[0].classList.add("isActive");

  function handleTabs() {
    tabsButtons.forEach((tab, index) => {
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        tabsButtons.forEach((btn) => btn.classList.remove("isActive"));
        tabsContents.forEach((content) => content.classList.remove("isActive"));
        tab.classList.add("isActive");
        if (tabsContents[index]) {
          tabsContents[index].classList.add("isActive");
        }
        updateGrid();
      });
    });
  }

  handleTabs();
}

const sectionGrid = document.querySelector("#programs-render");

const updateGrid = () => {
  const cityButtons = document.querySelectorAll(
    "#programs-render .isActive li"
  );

  if (!sectionGrid) {
    console.error("Elemento #programs-render no encontrado");
    return;
  }

  if (cityButtons.length < 3) {
    sectionGrid.classList.add("territory-maps__countries--min");
  } else {
    sectionGrid.classList.remove("territory-maps__countries--min");
  }
};

updateGrid();
